var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 230,
    viewBox: "0 0 230 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.513 58.7354L69.4581 6.98086C68.1812 4.85183 66.3747 3.08981 64.2145 1.86643C62.0543 0.643053 59.614 3.04806e-05 57.1315 0H7.20067C1.38327 0 -2.02182 6.54512 1.3114 11.3113L51.2961 82.7191C64.6469 70.2443 81.6274 61.6822 100.513 58.7354ZM222.799 0H172.869C167.819 0 163.138 2.65039 160.542 6.98086L129.487 58.7354C148.373 61.6822 165.353 70.2443 178.704 82.7147L228.689 11.3113C232.022 6.54512 228.617 0 222.799 0ZM115 71.875C71.3358 71.875 35.9373 107.273 35.9373 150.938C35.9373 194.602 71.3358 230 115 230C158.664 230 194.063 194.602 194.063 150.938C194.063 107.273 158.664 71.875 115 71.875ZM156.562 142.519L139.523 159.122L143.552 182.58C144.271 186.785 139.842 189.997 136.073 188.012L115 176.938L93.9316 188.012C90.1581 190.011 85.7333 186.781 86.4521 182.58L90.4816 159.122L73.4427 142.519C70.379 139.536 72.0725 134.33 76.2952 133.719L99.8478 130.287L110.373 108.94C111.321 107.017 113.154 106.07 114.991 106.07C116.837 106.07 118.684 107.031 119.631 108.94L130.157 130.287L153.709 133.719C157.932 134.33 159.626 139.536 156.562 142.519Z",
    fill: "#d0f0ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.1f5d92ae1c4f0d6c31f999a43e1fd327.svg";
export { ForwardRef as ReactComponent };